
<template>
    <div class="homeNewsRecShow clearfix">
        <template v-for="(item,index) in list" >
            <div class="hotShow" v-if="index==0" :key="index">
                  <router-link :to="{name:'newsdetail',params:{id:item.id}}">
                        <img :src="item.imgUrl">
                        <div class="info">
                            <div class="time">
                                <span class="year">{{utils.DateFormat(new Date(item.publishDate),'yyyy')}}</span>
                                <span class="date">{{utils.DateFormat(new Date(item.publishDate),'MM-dd')}}</span>
                            </div>
                            <div class="text_con">
                                <div class="title">{{item.title}}</div>
                                <div class="desc">{{item.zhaiyao}}</div>
                            </div>
                        </div>
                </router-link>
                
            </div>
        </template>
        <div class="list">
            <ul>
             <template v-for="(item,index) in list" >
                <li class="clearfix"  :key="index" v-if="index>0">
                <router-link :to="{name:'newsdetail',params:{id:item.id}}">
                    <div class="time">
                        <span class="year">{{utils.DateFormat(new Date(item.publishDate),'yyyy')}}</span>
                        <span class="date">{{utils.DateFormat(new Date(item.publishDate),'MM-dd')}}</span>
                    </div>
                    <div class="text_con">
                    <div class="title">{{item.title}}</div>
                    <div class="desc">{{item.zhaiyao}}</div>
                    </div>
                </router-link>
                </li>
             </template>
            </ul>
        </div>
    </div>
</template>

<script>
// import {Loading } from 'element-ui';
export default {
   props: ["id"],
  data(){
    return{
        list_category:[],
        list:[],
        total:0,
    }
  },
  created(){
    this.GetList();
  },
  components:{
    
  },
  methods:{

     GetList() {
        //    this.loadingInstance = Loading.service({
        //         // 动画中的文字
        //         text:'加载中',
        //         // 要加载动画的容器
        //         target:'.app-container'
        //     });
            var url = "/pageapi/News/GetList";
            this.$http.post(url,{pagesize: 5,CategoryId:this.id}).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){
            });
        },

  },
   watch:{
        id(){
           this.GetList();
        },
    }
}
</script>
